import React from "react";

//Components
import EtaTable from '../etaTable'
const EtaActive = (props) => {

    return (
        <div>
            <EtaTable {...props} showLink/>
        </div>
    )
}

export default EtaActive